import {GenUserPreferences} from '../../generated/serverModels/GenUserPreferences';

export class UserPreferences extends GenUserPreferences {


  constructor(userPreferences?: UserPreferences | GenUserPreferences) {
    super(userPreferences);

  }

}


